<template>
  <ul ref="notification-list" class="notification-list" @scroll="onScroll">
    <v-progress-circular
      v-if="loading"
      class="notification-list__loader"
      color="#424242"
      width="2"
      indeterminate
    />

    <div v-else-if="items.length === 0" class="notification-list__no-data">
      {{ $t('notifications.no-data') }}
    </div>

    <template v-else>
      <li v-for="item in items" :key="item.id">
        <notification class="notification-list__item" v-bind="item" />
      </li>
    </template>
  </ul>
</template>

<script>
import Notification from './Notification.vue';

export default {
  components: { Notification },
  props: {
    isViewed: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    viewedList: [],
  }),
  methods: {
    onScroll(e) {
      if (this.isViewed) return;
      this.setViewed(e);
    },

    setViewed() {
      const listElement = this.$refs['notification-list'];
      const visibleList = this.getVisibleNotificationIds(listElement);

      visibleList.forEach((id) => {
        const isAllreadyWritten = this.viewedList.includes(id);
        if (!isAllreadyWritten) this.viewedList.push(id);
      });
    },

    getVisibleNotificationIds(listElement) {
      const listCoords = listElement.getBoundingClientRect();
      const notifications = listElement.querySelectorAll(
        '.notification-list__item',
      );

      const viewedList = [...notifications].reduce((list, element) => {
        const elementCoords = element.getBoundingClientRect();
        const elementOffsetTop = elementCoords.top - listCoords.top;
        const isViewed = // eslint-disable-line
          elementCoords.height + elementOffsetTop < listCoords.height;

        if (isViewed) list.push(Number(element.dataset.id));

        return list;
      }, []);

      return viewedList;
    },
  },
  mounted() {
    setTimeout(() => {
      this.setViewed();
    }, 300);
  },
  beforeDestroy() {
    if (this.viewedList.length === 0) return;

    this.$store.dispatch(
      'notifications/sendViewedNotifications',
      this.viewedList,
    );
  },
};
</script>

<style lang="scss">
.notification-list {
  position: relative;
  height: 322px;
  margin: 0;
  padding: 10px !important;
  background-color: #eee;
  overflow-y: auto;
  scrollbar-color: #c9c9c9, transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    background-clip: padding-box;
    border-radius: 20px;
    border: solid 2px rgba(0, 0, 0, 0);
  }
  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  li {
    list-style: none;
    margin-bottom: 10px;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__no-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #777;
    font-size: 18px;
  }
}
</style>
